import type { Locale, LandingContent, LegalContent, SupportContent } from "./types";
import { landingEn } from "./en";
import { landingZh } from "./zh";
import { privacyEn } from "./privacy.en";
import { privacyZh } from "./privacy.zh";
import { termsEn } from "./terms.en";
import { termsZh } from "./terms.zh";
import { supportEn } from "./support.en";
import { supportZh } from "./support.zh";

export const landingByLocale: Record<Locale, LandingContent> = {
  en: landingEn,
  zh: landingZh
};

export const privacyByLocale: Record<Locale, LegalContent> = {
  en: privacyEn,
  zh: privacyZh
};

export const termsByLocale: Record<Locale, LegalContent> = {
  en: termsEn,
  zh: termsZh
};

export const supportByLocale: Record<Locale, SupportContent> = {
  en: supportEn,
  zh: supportZh
};
